// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25uiG","top":"styles_top__3Nogc"};